import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './pages/main/main.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './utils/guards/auth.guard';
import { NonAuthGuard } from './utils/guards/non-auth.guard';
import { NewUserGuard } from './utils/guards/new-user.guard';
import { GuestComponent } from './pages/guest/guest.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { OnboaringGuard } from './utils/guards/onboarding.guard';
import { TeleconsultResolverService } from './utils/resolver/teleconsult.resolver';
import { PaymentWallComponent } from './pages/payment-wall/payment-wall.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '', redirectTo: 'home', pathMatch: 'full'
      },
      {    
        path: 'home',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/home/home.module').then( m => m.HomeModule)
      },
      {
        path: 'consults',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/patient-worklist/patient-worklist.module').then( m => m.PatientWorklistModule)
      },
      {
        path: 'teleconsultation',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/teleconsultation/teleconsultation.module').then( m => m.TeleconsultationModule)
      },
      {
        path: 'profile',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/profile/profile.module').then( m => m.ProfileModule)
      },
      {
        path: 'patients',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/patients/patients.module').then( m => m.PatientsModule)
      },
      {
        path: 'patients-admin',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/patients-admin/patients.module').then( m => m.PatientsModule)
      },
      {
        path: 'in-patients',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/inpatients/inpatients.module').then( m => m.InpatientsModule)
      },
      {
        path: 'loa',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/loa/loa.module').then( m => m.LoaModule)
      },
      {
        path: 'patient',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/patient/patient.module').then( m => m.PatientModule)
      },
      {
        path: 'medical-billing',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/medical-billing/medical-billing.module').then( m => m.MedicalBillingModule)
      },
      {
        path: 'register',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/patient-registration/patient-registration.module').then( m => m.PatientRegistrationModule)
      },
      {
        path: 'reports',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/reports/reports.module').then( m => m.ReportsModule)
      },
      {
        path: 'settings',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/settings/settings.module').then( m => m.SettingsModule)
      },
      {
        path: 'staff-accounts',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/staff-accounts/staff-accounts.module').then( m => m.StaffAccountsModule)
      },
      {
        path: 'referrals',
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/referrals/referrals.module').then( m => m.ReferralsModule)
      },
      {
        path: 'onboarding',
        canActivate: [OnboaringGuard],
        loadChildren: () => import('./views/onboarding/onboarding.module').then( m => m.OnboardingModule)
      },
      {
        path: 'teleconsults',
        resolve: {
            telemed: TeleconsultResolverService
        },
        canActivate: [NewUserGuard],
        loadChildren: () => import('./views/teleconsults/teleconsults.module').then( m => m.TeleconsultsModule)
      },
    ]
  },
  {
    path: 'payment',
    canActivate: [AuthGuard],
    component: PaymentWallComponent
  },
  {
    path: 'account-verified',
    loadChildren: () => import('./pages/account-verified/account-verified.module').then( m => m.AccountVerifiedModule)
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./pages/sign-up/sign-up.module').then( m => m.SignUpModule)
  },
  {
    path: 'verify-email/:id',
    loadChildren: () => import('./pages/verify-email/verify-email.module').then( m => m.VerifyEmailModule)
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NonAuthGuard]
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordModule)
  },
  {
    path: 'reset-password/:id',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then( m => m.ResetPasswordModule)
  },
  {
    path: 'verify',
    loadChildren: () => import('./pages/verify/verify.module').then(m => m.VerifyModule)
  },
  // {
  //   path: 'guest-call',
  //   loadChildren: () => import('./pages/guest-call/guest-call.module').then( m => m.GuestCallModule)
  // },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'guest',
  //   loadChildren: () => import('./pages/guest/guest.module').then( m => m.GuestModule)
  // },
  // {
  //   path: '', redirectTo: 'login'
  // },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
